
import Component, { mixins } from 'vue-class-component';
import PlayerControlsMixin from '@/app/player/mixins/PlayerControlsMixin';
import TInput from '@/lib/form/input/Input.vue';
import TranscriptsPopover from '@/app/components/TranscriptsPopover.vue';

@Component({
  name: 'player-controls',
  components: {
    TInput,
    TranscriptsPopover
  }
})
export default class PlayerControls extends mixins(PlayerControlsMixin) {}
